import { render, staticRenderFns } from "./PhotoLibrary.vue?vue&type=template&id=fc21e13a&scoped=true"
import script from "./PhotoLibrary.vue?vue&type=script&lang=js"
export * from "./PhotoLibrary.vue?vue&type=script&lang=js"
import style0 from "./PhotoLibrary.vue?vue&type=style&index=0&id=fc21e13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc21e13a",
  null
  
)

export default component.exports